import { combineReducers } from "redux";
import { commonReducer } from "./common-reducer";
import { queryParametersReducer } from "./query-parameters-reducer";
import { submissionReducer } from "./submission-reducer";
import { verificationConfigurationReducer } from "./verification-configuration-reducer";
import { verificationFormReducer } from "./verification-form-reducer";
import { errorReducer } from "./error-reducer";
import { languageReducer } from "./language-reducer";

export const rootReducer = combineReducers({
    common: commonReducer,
    error: errorReducer,
    language: languageReducer,
    queryParameters: queryParametersReducer,
    submission: submissionReducer,
    verificationConfiguration: verificationConfigurationReducer,
    verificationForm: verificationFormReducer,
});